module.exports = __webpack_public_path__ + "img/fasilitas.22de04ff.png";